module.exports = __webpack_public_path__ + "img/金钱白花蛇.8b8a525d.jpg";